import React from 'react';
import { T } from './authStyles';

export default function Divider({ label }) {
  return (
    <div style={T.divider}>
      <div style={T.dividerLine} />
      <span style={T.dividerText}>{label}</span>
      <div style={T.dividerLine} />
    </div>
  );
}
